export default "__VITE_ASSET__DiPqIKHi__"